import { useSelector } from 'react-redux';
import AppRoutes from './routes/AppRoutes';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { RootState } from './redux-stores/store';
import { useEffect } from 'react';
import useCheckVersion from './hooks/useCheckVersion';
import { APP_ENV } from './constants/constants';
import { initDeviceDetection } from './utils/deviceDetection';
import { analyticsLog } from './contexts/FirebaseContext';

const RouteTracker = () => {
    const location = useLocation();
    useEffect(() => {
        if(APP_ENV !== 'production') return;
        if ((window as any).fbq) {
            (window as any).fbq('track', 'PageView');
        }
        analyticsLog('page_view', {
            location
        })
    }, [location]);
    return null;
};

function App() {
    const mode = useSelector((state: RootState) => state.theme.mode);

    useCheckVersion(); // Automatically refreshes on a new build

    // Sync the theme with document body classList when mode changes
    useEffect(() => {
        document.body.classList.toggle('theme-dark', mode === 'dark');
        document.body.classList.toggle('theme-light', mode === 'light');
    }, [mode]);

    useEffect(() => {
        // Initialize device detection on app load
        initDeviceDetection();
    }, [])

    useEffect(() => {
        if (!("serviceWorker" in navigator)) return;

        navigator.serviceWorker.getRegistrations().then(registrations => {
            registrations.forEach(reg => reg.unregister());
        });

        // Important: clear PWA caches too
        if ("caches" in window) {
            caches.keys().then(keys => {
            keys.forEach(key => caches.delete(key));
            });
        }
    }, []);


    return (
        <div id="page">
            <BrowserRouter>
                <RouteTracker />
                <AppRoutes />
            </BrowserRouter>
        </div>
    );
}

export default App;
